import React from "react";
import { AppLayout } from "../shared/layout";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import {
  FileText,
  Settings,
  Mail,
  Search,
  DollarSign,
  TrendingUp,
  Flag,
} from "lucide-react";

const quickLinks = [
  {
    title: "All Invoices",
    description: "View and manage all invoices",
    path: "/invoices-all",
    icon: FileText,
    gradient: "from-emerald-500 to-teal-600",
    hoverGradient: "hover:from-emerald-600 hover:to-teal-700",
  },
  {
    title: "Invoices Operations",
    description: "Manage invoice operations",
    path: "/invoices-operations",
    icon: Settings,
    gradient: "from-blue-500 to-indigo-600",
    hoverGradient: "hover:from-blue-600 hover:to-indigo-700",
  },
  {
    title: "Mail Sended Commissions",
    description: "Track commission emails",
    path: "/invoices-operations-commission",
    icon: DollarSign,
    gradient: "from-amber-500 to-orange-600",
    hoverGradient: "hover:from-amber-600 hover:to-orange-700",
  },
  {
    title: "Mail Send Operations",
    description: "Manage email operations",
    path: "/mail-send-operations",
    icon: Mail,
    gradient: "from-purple-500 to-pink-600",
    hoverGradient: "hover:from-purple-600 hover:to-pink-700",
  },
  {
    title: "Influencer Search",
    description: "Search and find influencers",
    path: "/influencer-search",
    icon: Search,
    gradient: "from-cyan-500 to-blue-600",
    hoverGradient: "hover:from-cyan-600 hover:to-blue-700",
  },
  {
    title: "Azerbaijan < $10",
    description: "Azerbaijan commissions under $10",
    path: "/azerbaijan-low-amount",
    icon: Flag,
    gradient: "from-rose-500 to-red-600",
    hoverGradient: "hover:from-rose-600 hover:to-red-700",
  },
];

export function HomeScreen() {
  return (
    <AppLayout title="Quick Links">
      <div className="px-4 py-8">
        {/* Header Section */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold tracking-tight text-foreground mb-2">
            Quick Links
          </h1>
          <p className="text-muted-foreground">
            Access your most used features quickly
          </p>
        </div>

        {/* Quick Links Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {quickLinks.map((link) => {
            const Icon = link.icon;
            return (
              <Link
                key={link.path}
                to={link.path}
                className="group block transition-transform hover:scale-105"
              >
                <Card className="h-full border-2 hover:border-primary/50 transition-all duration-300 hover:shadow-xl overflow-hidden">
                  <CardContent className="p-0">
                    {/* Gradient Header */}
                    <div
                      className={`bg-gradient-to-br ${link.gradient} ${link.hoverGradient} p-6 transition-all duration-300`}
                    >
                      <div className="flex items-center justify-between">
                        <Icon className="h-10 w-10 text-white drop-shadow-lg" />
                        <div className="h-12 w-12 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center group-hover:bg-white/30 transition-colors">
                          <TrendingUp className="h-6 w-6 text-white" />
                        </div>
                      </div>
                    </div>

                    {/* Content */}
                    <div className="p-6">
                      <h3 className="text-xl font-semibold text-foreground mb-2 group-hover:text-primary transition-colors">
                        {link.title}
                      </h3>
                      <p className="text-sm text-muted-foreground">
                        {link.description}
                      </p>
                    </div>

                    {/* Footer */}
                    <div className="px-6 pb-6">
                      <Button
                        variant="ghost"
                        className="w-full group-hover:bg-primary/10 group-hover:text-primary transition-colors"
                      >
                        Open →
                      </Button>
                    </div>
                  </CardContent>
                </Card>
              </Link>
            );
          })}
        </div>
      </div>
    </AppLayout>
  );
}
